import type { ViewBinding, ViewId, ViewType } from './contract.js';
import { unmetRequirement } from './assertBinding.js';

/** Le catalogue effectif, identique pour le rendu, l'adresse et la navigation. */
export function typesDePorte(
  porte: { canvas?: unknown; types?: ViewType[]; viewIds?: readonly ViewId[] } | null | undefined,
  catalogue: ViewType[],
): ViewType[] {
  if (porte?.canvas != null) return [];
  const types = porte?.types ?? catalogue;
  if (porte?.viewIds === undefined) return types;
  const parId = new Map(types.map((type) => [type.id, type]));
  return porte.viewIds.flatMap((id) => {
    const type = parId.get(id);
    return type === undefined ? [] : [type];
  });
}

/** Une vue grisee reste proposee, mais ne devient pas la vue d'arrivee. */
export function vueDeCollection<T>(
  types: ViewType[], bindings: ViewBinding<T>[], candidate?: ViewId | null, defaut?: ViewId,
): ViewId | undefined {
  const collections = types.filter((type) => type.level === 'collection');
  const disponibles = collections.filter((type) => unmetRequirement(type, bindings.find((b) => b.type === type.id)) == null);
  return disponibles.find((type) => type.id === candidate)?.id
    ?? disponibles.find((type) => type.id === defaut)?.id
    ?? disponibles[0]?.id
    ?? collections.find((type) => type.id === defaut)?.id
    ?? collections[0]?.id;
}
